import React from 'react'

import cx from 'classnames'
import styles from './DeleteMediaModal.module.scss'
import Text from '../../../../components/Text'
import Button from '../../../../components/Button'
import { useTranslation } from 'react-i18next'
import { Media } from '../../../../types/Media'
import { useDeleteData } from '../../../../hooks/useDeleteData'
import { ApiRoutes } from '../../../../services/ApiService'
import { closeModal } from '../../../../services/ModalService'
import { showToast } from '../../../../services/ToastService'

const DeleteMediaModal: React.FC<{ media: Media; onSubmit: () => void }> = ({
    media,
    onSubmit,
}) => {
    const { t } = useTranslation(['settings'])
    const { submit } = useDeleteData(ApiRoutes.MEDIA, media.id)

    const handleSubmit = () => {
        submit().then((res) => {
            if (res.status === 204) {
                closeModal()
                showToast(t('media.delete_modal.success'))
            } else {
                showToast(t('media.delete_modal.error'), 'error')
            }
            onSubmit()
        })
    }

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <Text>
                {t('media.delete_modal.sub_heading', {
                    media_name: media.name,
                })}
            </Text>
            <Button
                hierarchy={'primary'}
                text={t('media.delete_modal.delete')}
                fn={() => handleSubmit()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('common.abort')}
                fn={() => closeModal()}
                classes={'zr-w-100 zr-mx-4 zr-my-2'}
            />
        </div>
    )
}

export default DeleteMediaModal
